import { Sim } from '../../game/simulation';

/**
 * Floating "Back to overview" pill — visible only while a plot session
 * is active. With the dock hidden in plot mode this is the explicit
 * affordance to leave; ESC still works too.
 */
export class ExitPlotButton {
  private root: HTMLButtonElement;

  constructor(parent: HTMLElement, private sim: Sim) {
    this.root = document.createElement('button');
    this.root.className = 'ui-exitplot';
    this.root.innerHTML = `<span>←</span> Exit Plot <kbd>ESC</kbd>`;
    this.root.style.display = 'none';
    this.root.addEventListener('click', () => this.sim.exitPlot());
    parent.appendChild(this.root);

    sim.bus.on(e => {
      if (e.type === 'plotEntered') this.root.style.display = '';
      else if (e.type === 'plotExited') this.root.style.display = 'none';
    });
  }
}
